module.exports = __webpack_public_path__ + "static/media/OT4@2x.0f907c6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MapElements/OT/OT4@2x.png
// module id = 715
// module chunks = 0